import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-autorization-modal',
  templateUrl: './autorization-modal.component.html',
  styleUrl: './autorization-modal.component.scss',
  providers: []
})
export class AutorizationModalComponent {
  @Input() title: string = '';
  @Output() close = new EventEmitter<void>();

    closeModal() {
      this.close.emit();
    }
}
